export const columnTypes = {
    NUMERIC:0,
    TEXT:1,
    DATE:2
}